const ITEM_CONTEXT = {
    BUSINESS_REVIEW: 'BUSINESS_review',
};
const SEPARATOR = '|';

export const itemContext = ({ isBusiness = false }) => {
    const itemContext = [];
    isBusiness && itemContext.push(ITEM_CONTEXT.BUSINESS_REVIEW);

    return itemContext.join(SEPARATOR);
};
